import { DatePicker, Form, Input, Select, Spin } from "antd";
import React, { useRef, useState } from "react";
import rpmService from "../../../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import { convertUTCDate } from "../../../../../../../utils/convertionFunc";
import DrugServices from "../../../../../../../Services/DrugServices";
import { fetchRpmCPMedicationsList } from "../../../../../../../Redux/actions/rpmActions";
import { Option } from "antd/es/mentions";
import moment from "moment";
import dayjs from "dayjs";

function AddNewMedication({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const [medicines, setMedicines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMedicine, setSelectedMedicine] = useState(null);
  const [searchedManualMed, setSearchedManualMed] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [composition, setComposition] = useState("");
  const dispatch = useDispatch();
  const formRef = useRef();
  const InputRef = useRef();
  const [form] = Form.useForm();
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const loggedUserObj = localStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  const handleNewMedicationSave = async () => {
    const {
      dosage,
      adverseEffects,
      adviceRelatedMedicine,
      compliance,
      dose,
      frequency,
      indication,
      sideEffects,
      duration,
      durationtype,
      fromdate,
    } = formRef.current.getFieldValue();

    let finalPayloadArr = [];
    setLoader(true);

    let toDate = null;
    if (fromdate && duration && durationtype) {
      const durationInt = parseInt(duration);
      if (!isNaN(durationInt)) {
        switch (durationtype) {
          case "Days":
            toDate = dayjs(fromdate).add(durationInt, "day");
            break;
          case "Weeks":
            toDate = dayjs(fromdate).add(durationInt, "week");
            break;
          case "Months":
            toDate = dayjs(fromdate).add(durationInt, "month");
            break;
          default:
            toDate = fromdate;
        }
      }
    }

    const payload = {
      account_Id: selectedRpmPatient.account_Id,
      clinic_Id: selectedRpmPatient.clinic_id,
      userId: selectedRpmPatient.createdBy,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      givenDate: convertUTCDate(fromdate, "YYYY-MM-DD HH:mm:ss"),
      createdBy: loggedUser?.user?.userId,
      modifiedBy: loggedUser?.user?.userId,
      status: 1,
      patientCode: selectedRpmPatient.patientId,
      enteredBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      startCreatedTime: convertUTCDate(fromdate, "YYYY-MM-DD HH:mm:ss"),
      endCreatedTime: toDate
        ? convertUTCDate(toDate, "YYYY-MM-DD HH:mm:ss")
        : null, //based on duration and duration type need to calculate to date
      adverseEffects,
      adviceRelatedMedicine,
      compliance,
      composition: selectedMedicine?.saltComposition,
      dosage: dosage,
      dose,
      drugName: selectedMedicine
        ? selectedMedicine.medicineName
        : searchedManualMed,
      frequency,
      indication,
      sideEffects,
      duration,
      durationType: durationtype,
      rpm: "Y",
    };

    finalPayloadArr.push(payload);

    try {
      await rpmService.AddMedication(finalPayloadArr);
      const payload = {
        patientCode: selectedRpmPatient.patientId,
        rpm: "Y",
        status: 1,
      };
      dispatch(fetchRpmCPMedicationsList(payload));
      setLoader(false);
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  const onSearch = async (value) => {
    if (value.length !== 0) {
      try {
        setIsLoading(true);
        const res = await DrugServices.fetchDrugList(value);
        if (res?.data?.data?.length > 0) {
          setMedicines(res?.data?.data);
        } else {
          setSearchedManualMed(value);
        }
        setIsLoading(false);
      } catch (e) {
        console.error(e);
      }
    }
  };

  const handleChange = (value) => {
    if (value && value.length !== 0) {
      // DrugServices.fetchDrugList(value.label).then((res) => {
      //     setSelectedMedicine(res.data[0]);
      // });
      const selectedMed = medicines.find((med) => med.doxzonDrugId === value);
      setSelectedMedicine(selectedMed);
      selectedMed &&
        formRef.current.setFieldsValue({
          composition: selectedMed.saltComposition,
        });
    } else {
      setSelectedMedicine(null);
    }
  };

  const handleManualMedChange = (e) => {
    setSearchedManualMed(e.target.value);
  };

  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const options = [
    "0-0-1",
    "0-1-1",
    "0-1-0",
    "1-1-1",
    "1-0-0",
    "1-0-1",
    "1-1-0",
    "1-1-1-1",
    "1-0-0-1",
    "1-0-0-0",
    "1-1-0-0",
    "1-1-1-0",
    "0-0-0-1",
    "0-0-1-1",
    "0-0-1-0",
    "0-1-0-0",
    "0-1-1-1",
    "s.o.s",
    "q.wk.",
    "b.i.d.",
    "t.i.d.",
    "q.i.d.",
    "q.h.s.",
    "5X a day",
    "q.4h",
    "q.6h",
    "q.0.d.",
    "prn.",
    "q.d.",
    "I.M.",
    "Subq.",
    "Rectally",
    "I.V.",
    "O.D.",
    "O.S.",
    "O.U.",
    "2 ml",
    "2.5 ml",
    "5 ml",
    "10 ml",
  ];

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handleDate = (date, dateString) => {
    if (dateString) {
      const constructedTime = dateString + " " + "00:00:00";
      setFromDate(constructedTime);
    } else {
      setFromDate("");
    }
  };

  return (
    <div>
      <Form form={form} ref={formRef} layout="vertical">
        <div className="grid grid-cols-2 gap-3 p-4">
          <div>
            <Form.Item
              label={
                <span>
                  Drug Name <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="medicineName"
            >
              <Select
                onSearch={onSearch}
                onChange={handleChange}
                showSearch
                placeholder="Enter Medicine Name"
                className={`${
                  !searchedManualMed ? "block" : "hidden"
                } w-full h-8`}
                options={medicines.map((medicine) => {
                  return {
                    label: medicine.medicineName,
                    value: medicine.doxzonDrugId,
                  };
                })}
                filterOption={(input, option) =>
                  option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                notFoundContent={
                  isLoading ? (
                    <div className="text-center">
                      <Spin size="small" />
                    </div>
                  ) : null
                }
                allowClear
              />
              <Input
                type="text"
                className={`${
                  searchedManualMed ? "block" : "hidden"
                } w-full h-8`}
                value={searchedManualMed}
                onChange={handleManualMedChange}
                ref={InputRef}
              />
            </Form.Item>
          </div>

          <div>
            <Form.Item name={"composition"} label={<span>Composition </span>}>
              <Input
                value={
                  !searchedManualMed
                    ? selectedMedicine?.saltComposition
                    : composition
                }
                disabled={!searchedManualMed}
                className="h-8 w-full rounded-md border-gray-200 px-4 outline-none border"
                onChange={(e) => setComposition(e.target.value)}
              />
            </Form.Item>
          </div>

          <div>
            <Form.Item
              label={<span>Dosage </span>}
              className="gutter-row"
              name="dosage"
            >
              <Input rows={2} placeholder="Enter Dosage" />
            </Form.Item>
          </div>

          <div>
            <Form.Item label={<span>Frequency </span>} name="frequency">
              <Select placeholder="Select Frequency">
                {options.map((option, index) => (
                  <Option key={index} value={option}>
                    {option}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </div>

          <div>
            {/* <label><span>Duration <span style={{ color: "#FF000F" }}>*</span></span></label> */}
            <div className="w-full flex items-center rounded-lg">
              <Form.Item
                label={<span>Duration </span>}
                name="duration"
                className="w-2/4 h-[inherit]"
              >
                <Input
                  onKeyPress={handleKeyPress}
                  rows={2}
                  placeholder="Enter Duration"
                />
              </Form.Item>
              <Form.Item
                label={<span>Type </span>}
                name="durationtype"
                className="w-2/4 h-[inherit]"
              >
                <Select
                  placeholder="Select Duration Type"
                  className="border-none"
                >
                  <Select.Option value="Days">Days</Select.Option>
                  <Select.Option value="Weeks">Weeks</Select.Option>
                  <Select.Option value="Months">Months</Select.Option>
                </Select>
              </Form.Item>
            </div>
          </div>

          <div>
            <Form.Item label={<span>Indication </span>} name="indication">
              <Input rows={2} placeholder="Enter Indication" />
            </Form.Item>
          </div>

          <div>
            <Form.Item label={<span>Side effect </span>} name="sideEffects">
              <Input rows={2} placeholder="Enter Side Effect" />
            </Form.Item>
          </div>

          <div>
            <Form.Item label={<span>Compliance </span>} name="compliance">
              <Input rows={2} placeholder="Enter Compliance" />
            </Form.Item>
          </div>

          <div>
            <Form.Item
              label={<span>Adverse effect </span>}
              name="adverseEffects"
            >
              <Input rows={2} placeholder="Enter Adverse Effect" />
            </Form.Item>
          </div>

          <div>
            <Form.Item
              label={<span>Medicines advice by the doctor </span>}
              name="adviceRelatedMedicine"
            >
              <Input rows={2} placeholder="Enter " />
            </Form.Item>
          </div>

          <div>
            <Form.Item
              label={
                <span>
                  From / Checkup Date{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="fromdate"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex justify-end gap-3">
        <button
          onClick={handleClose}
          className="px-4 py-1 border rounded border-gray-400 text-sm bg-white text-cyan-700"
        >
          Cancel
        </button>
        <button
          disabled={isSubmitted}
          onClick={handleNewMedicationSave}
          className="px-4 py-1 bg-brand-primaryColor text-white rounded text-sm"
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default AddNewMedication;
